module.exports = __webpack_public_path__ + "img/aws.9ce170bb.svg";